let routes = [
    {
        name: 'Inventory',
        icon: 'account_balance',
        permission: 'staff-create',
        header: true,
        children: [
            {
                name: 'Settings',
                icon: 'account_balance',
                permission: 'staff-create',
                children: [
                    {
                        name: 'Category',
                        path: 'category',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Warehouse',
                        path: 'warehouse',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Unit',
                        path: 'unit',
                        icon: 'business',
                        permission: 'staff-create',
                    }
                ]
            },
            {
                name: 'Activity',
                icon: 'account_balance',
                permission: 'staff-create',
                children: [
                    {
                        name: 'Create Item',
                        path: 'item-create',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Create Purchase',
                        path: 'purchase',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Purchase Return',
                        path: 'purchase-return',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Create Sales',
                        path: 'sales',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Sales Return',
                        path: 'sales-return',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                ]
            },
            {
                name: 'Reports',
                icon: 'account_balance',
                permission: 'staff-create',
                children: [
                    {
                        name: 'Items',
                        path: 'item',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Purchases',
                        path: 'purchase-report',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Purchase Return Report',
                        path: 'purchase-return-report',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Sales Report',
                        path: 'sales-report',
                        icon: 'business',
                        permission: 'staff-create',
                    },
                    {
                        name: 'Sales Return Report',
                        path: 'sales-return-report',
                        icon: 'business',
                        permission: 'staff-create',
                    }
                ]
            }
        ]
    },
];

export default routes;